import * as React from 'react'
import { View } from 'react-native'
import styled from '@theme/styled-components'

import Tag from '@components/tag/Tag'

import useOutsideClick from '@utils/useOutsideClick'

interface Props {
  open: boolean
  onOpen: (open: boolean) => void
  name: string
  active?: boolean
  children: React.ReactNode
}

const FilterLayout = ({ open, onOpen, name, active, children }: Props) => {
  const filter = React.useRef<View>(null)

  useOutsideClick(filter, () => onOpen(false))

  return (
    <View>
      <Tag item={{ label: name, value: name }} onItemSelected={() => onOpen(!open)} selected={active} inactiveColor />
      {open && <FilterOverView ref={filter}>{children}</FilterOverView>}
    </View>
  )
}

export default FilterLayout

const FilterOverView = styled(View)`
  position: absolute;
  border-radius: 8px;
  top: 60px;
  min-width: 350px;
  height: 500px;
  z-index: 10;
  background-color: ${(props) => props.theme.colors.background};
  ${(props) => props.theme.constants.shadow};
`
